import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import NetResultBand from '@/components/feature/NetResultBand';
import { useScrollToHash } from '@/hooks/useScrollToHash';
import { injectJsonLd, siteUrl } from '@/utils/structuredData';
import { applyPageSeo } from '@/utils/seo';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import WaitTrade from './components/WaitTrade';
import GoldStrategy from './components/GoldStrategy';
import NoForecast from './components/NoForecast';
import ProcessPath from './components/ProcessPath';
import NumbersDashboard from './components/NumbersDashboard';
import RiskData from './components/RiskData';
import TradeJournalPreview from './components/TradeJournalPreview';
import AccountPerformance from './components/AccountPerformance';
import MT5Section from './components/MT5Section';
import ExpertVoices from './components/ExpertVoices';

export default function Home() {
  useScrollToHash();

  useEffect(() => {
    const removeSeo = applyPageSeo({
      title: 'XAUUSD MT5 Expert Advisor | GoldEA Systematic Gold Trading',
      description:
        'GoldEA is a systematic MT5 Expert Advisor built exclusively for XAUUSD. Rule-based execution, transparent trade records and an honest risk profile for gold traders.',
      keywords: 'XAUUSD EA, gold Expert Advisor, MT5 EA, systematic gold trading, gold trade journal',
      path: '/',
    });

    // Organization + WebSite markup so search engines recognise the brand and
    // its site as one entity. Only facts shown on the page are declared.
    const removeBrandSchema = injectJsonLd({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          name: 'GOLDEA',
          url: siteUrl('/'),
          description: 'XAUUSD-focused MT5 Expert Advisor.',
        },
        {
          '@type': 'WebSite',
          name: 'GOLDEA',
          url: siteUrl('/'),
          inLanguage: 'en',
          publisher: { '@type': 'Organization', name: 'GOLDEA' },
        },
      ],
    });
    return () => {
      removeSeo();
      removeBrandSchema();
    };
  }, []);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader current="home" />
      <main>
        <Hero />
        <NetResultBand />
        <Philosophy />
        <WaitTrade />
        <GoldStrategy />
        <NoForecast />
        <ProcessPath />
        <NumbersDashboard />
        <RiskData />
        <TradeJournalPreview />
        <AccountPerformance />
        <MT5Section />
        <ExpertVoices />
      </main>
      <SiteFooter current="home" />
    </div>
  );
}